import type { ReactNode } from 'react';

import { TableRow, TableData, generateQeId, Icon } from '@ctct/ui-react';

export const PriceEstimatorDialogTier = ({ index, children }: { index: number; children?: ReactNode }) => {
  return <TableRow data-qe-id={generateQeId('new-selector-tier-row-', index)}>{children}</TableRow>;
};

export const PriceEstimatorDialogContacts = ({ children }: { children?: ReactNode }) => (
  <TableData className="price-estimator-contact-col">{children}</TableData>
);

export const PriceEstimatorDialogPricing = ({ children }: { children?: ReactNode }) => (
  <TableData className="price-estimator-pricing-col">{children}</TableData>
);

export const PriceEstimatorDialogCheckboxColumn = ({ isChecked = false }: { isChecked?: boolean }) => (
  <TableData className="price-estimator-checkbox-col">{isChecked ? <Icon glyph="check" /> : null}</TableData>
);
